// @flow
export const MODEL = 'Orders'
export const TREE = 'ordersData'
export const BRANCH = 'orders'

export const OPERATIONS_TREE = 'ordersModule'
export const OPERATIONS_BRANCH = 'operations'

// Api End Point
export const URL = 'hefty/order/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_IS_LOADING = 'isLoading'
export const PROP_ORDER = 'order'
export const PROP_USER_BILLING_INFO = 'userBillingInfo'
export const PROP_CLIENT = 'client'
export const PROP_ADDRESS = 'address'
export const PROP_CITY = 'city'
export const PROP_PROVINCE = 'province'
export const PROP_POSTAL_CODE = 'postal_code'
export const PROP_COUNTRY = 'country'
export const PROP_PHONE = 'phone'
export const PROP_MOBILE_PHONE = 'mobile_phone'
export const PROP_EMAIL = 'email'
export const PREFERRED_CONTACT = 'preferred_contact'
export const PROP_ORDERED_DATE = 'ordered_date'
export const PROP_CALCULATED_SALES_TAX = 'calculated_sales_tax'
export const ORDER_TOTAL = 'order_total'
export const SUPPLIES = 'supplies'
export const PROP_SUPPLY_QUANTITY = 'supplyQuantity'
export const PROP_SHIPPING_PACKAGE_TYPE = 'shippingPackageType'
export const PROP_PAYMENT_SESSION_ID = 'payment_session_id'
export const PROP_CLIENT_SECRET = 'client_secret'

// Shipping Package Types
export const BOX = 'Box'
export const BAG = 'Bag'

// Payment Statuses
export const PENDING = 'Pending'
export const PAYMENT_RECEIVED = 'Payment Received'
export const SUBMITTED = 'Submitted'
